import * as i0 from '@angular/core';
import { ChangeDetectionStrategy, Component, EventEmitter, Injectable, Directive, output, signal, HostListener, Input, ViewChildren, ContentChildren } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import * as i1 from '@esders/gui';
import { IDialog } from '@esders/gui';
import { TextFormatterPipe } from '@esders/utilities';
import { MatIcon } from '@angular/material/icon';
import { NgClass, NgTemplateOutlet } from '@angular/common';
const _c0 = ["mobileMenu"];
const _c1 = a0 => ({
  "header-fix": a0
});
const _c2 = a0 => ({
  "show-mobile-menu": a0
});
function HeaderComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵlistener("click", function HeaderComponent_Conditional_0_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.mobileMenuVisible = !ctx_r1.mobileMenuVisible());
    });
    i0.ɵɵelementEnd();
  }
}
function HeaderComponent_Conditional_34_For_8_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 19);
    i0.ɵɵlistener("click", function HeaderComponent_Conditional_34_For_8_Conditional_0_Template_li_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const lang_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.switchLang(lang_r4.iso));
    });
    i0.ɵɵelementStart(1, "div", 18);
    i0.ɵɵelement(2, "div", 20);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const lang_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵclassMapInterpolate1("spritesheet flag-", lang_r4.iso, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", lang_r4.title, " ");
  }
}
function HeaderComponent_Conditional_34_For_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HeaderComponent_Conditional_34_For_8_Conditional_0_Template, 4, 4, "li");
  }
  if (rf & 2) {
    const lang_r4 = ctx.$implicit;
    const activeLanguage_r5 = i0.ɵɵnextContext();
    i0.ɵɵconditional(lang_r4.iso != activeLanguage_r5.iso ? 0 : -1);
  }
}
function HeaderComponent_Conditional_34_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul")(1, "li")(2, "div", 18);
    i0.ɵɵelement(3, "div");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "mat-icon");
    i0.ɵɵtext(5, "keyboard_arrow_down");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "ul");
    i0.ɵɵrepeaterCreate(7, HeaderComponent_Conditional_34_For_8_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵclassMapInterpolate1("spritesheet flag-", ctx.iso, "");
    i0.ɵɵadvance(4);
    i0.ɵɵrepeater(ctx_r1.languages());
  }
}
function HeaderComponent_For_37_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementContainer(1, 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", item_r6.templateRef);
  }
}
function HeaderComponent_For_44_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 16, 0);
    i0.ɵɵelementContainer(2, 21);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r7 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", item_r7.templateRef);
  }
}
function HeaderComponent_Conditional_45_For_7_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵlistener("click", function HeaderComponent_Conditional_45_For_7_Conditional_0_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const lang_r9 = i0.ɵɵnextContext().$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.switchLang(lang_r9.iso));
    });
    i0.ɵɵelement(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const lang_r9 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("spritesheet flag-", lang_r9.iso, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", lang_r9.title, " ");
  }
}
function HeaderComponent_Conditional_45_For_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, HeaderComponent_Conditional_45_For_7_Conditional_0_Template, 3, 4, "a");
  }
  if (rf & 2) {
    const lang_r9 = ctx.$implicit;
    const activeLanguage_r10 = i0.ɵɵnextContext();
    i0.ɵɵconditional(lang_r9.iso != activeLanguage_r10.iso ? 0 : -1);
  }
}
function HeaderComponent_Conditional_45_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 16, 0)(2, "a");
    i0.ɵɵelement(3, "div");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 22);
    i0.ɵɵrepeaterCreate(6, HeaderComponent_Conditional_45_For_7_Template, 1, 1, null, null, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const activeLanguage_r10 = ctx;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵclassMapInterpolate1("spritesheet flag-", activeLanguage_r10.iso, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", activeLanguage_r10.title, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵrepeater(ctx_r1.languages());
  }
}
let DisclaimerDialogComponent = /*#__PURE__*/(() => {
  class DisclaimerDialogComponent extends IDialog {
    constructor() {
      super();
    }
    setDialogData(_) {}
    buttonPressed(button) {
      this.closeDialog(button);
    }
    static {
      this.ɵfac = function DisclaimerDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DisclaimerDialogComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: DisclaimerDialogComponent,
        selectors: [["esd-theme-disclaimer-dialog"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 5,
        vars: 5,
        consts: [[2, "padding-bottom", "1rem"], [3, "innerHTML"]],
        template: function DisclaimerDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h2", 0);
            i0.ɵɵtext(1, "Esders Connect \u2013 Disclaimer");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(2, "div", 1);
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵpipe(4, "textFormatter");
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind1(4, 3, i0.ɵɵpipeBind1(3, 1, "m_esders_connect_disclaimer")), i0.ɵɵsanitizeHtml);
          }
        },
        dependencies: [TranslatePipe, TextFormatterPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return DisclaimerDialogComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DisclaimerService = /*#__PURE__*/(() => {
  class DisclaimerService {
    constructor(_dialogService) {
      this._dialogService = _dialogService;
      this.onDisclaimerChoosen = new EventEmitter();
    }
    chooseDisclaimer(onlyShow) {
      const buttons = onlyShow ? ["t_done"] : ["t_decline", "t_accept"];
      this._dialogService.showDialog(DisclaimerDialogComponent, buttons).then(result => {
        this.onDisclaimerChoosen.emit(["t_done", "t_accept"].includes(result));
      });
    }
    static {
      this.ɵfac = function DisclaimerService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DisclaimerService)(i0.ɵɵinject(i1.DialogService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DisclaimerService,
        factory: DisclaimerService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return DisclaimerService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FooterComponent = /*#__PURE__*/(() => {
  class FooterComponent {
    constructor(disclaimerService) {
      this.disclaimerService = disclaimerService;
    }
    showDisclaimer() {
      this.disclaimerService.chooseDisclaimer(true);
    }
    static {
      this.ɵfac = function FooterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || FooterComponent)(i0.ɵɵdirectiveInject(DisclaimerService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: FooterComponent,
        selectors: [["esd-theme-footer"]],
        decls: 16,
        vars: 21,
        consts: [[1, "row", "menue"], [3, "href"], [3, "click"]],
        template: function FooterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "a", 1);
            i0.ɵɵpipe(2, "translate");
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "a", 1);
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵtext(7);
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(9, "a", 1);
            i0.ɵɵpipe(10, "translate");
            i0.ɵɵtext(11);
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(13, "a", 2);
            i0.ɵɵlistener("click", function FooterComponent_Template_a_click_13_listener() {
              return ctx.showDisclaimer();
            });
            i0.ɵɵtext(14);
            i0.ɵɵpipe(15, "translate");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate("href", i0.ɵɵpipeBind1(2, 7, "links.contact"), i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 9, "t_contact"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("href", i0.ɵɵpipeBind1(6, 11, "links.imprint"), i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 13, "t_imprint"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("href", i0.ɵɵpipeBind1(10, 15, "links.privacy_policy"), i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(12, 17, "t_privacy"));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(15, 19, "t_disclaimer"));
          }
        },
        dependencies: [TranslatePipe],
        styles: ["[_nghost-%COMP%]{position:relative;display:block;width:100%;height:69px;border-top:1px #e2001a solid;background:#333}@media only screen and (min-width : 601px) and (max-width : 992px){[_nghost-%COMP%]{height:80px}}@media only screen and (max-width : 600px){[_nghost-%COMP%]{height:160px}}[_nghost-%COMP%]   .menue[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center;height:69px}[_nghost-%COMP%]   .menue[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#fff;text-decoration:none;padding:1rem}[_nghost-%COMP%]   .menue[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{text-decoration:underline;cursor:pointer}@media only screen and (max-width : 600px){[_nghost-%COMP%]   .menue[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{flex-basis:100%;max-width:100%}}"],
        changeDetection: 0
      });
    }
  }
  return FooterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MenuitemDirective = /*#__PURE__*/(() => {
  class MenuitemDirective {
    constructor(templateRef) {
      this.templateRef = templateRef;
    }
    static {
      this.ɵfac = function MenuitemDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || MenuitemDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: MenuitemDirective,
        selectors: [["", "esdThemeMenuItem", ""]]
      });
    }
  }
  return MenuitemDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const GERMAN_LANG = {
  title: "Deutsch",
  iso: "de"
};
const CZECH_LANG = {
  title: "česky",
  iso: "cs"
};
const ENGLISH_LANG = {
  title: "English",
  iso: "en"
};
const SPAIN_LANG = {
  title: "Español",
  iso: "es"
};
const NETHERLANDS_LANG = {
  title: "Nederlands",
  iso: "nl"
};
const POLISH_LANG = {
  title: "polski",
  iso: "pl"
};
const PORTUGUESE_LANG = {
  title: "Português",
  iso: "pt"
};
const RUSSIAN_LANG = {
  title: "русский",
  iso: "ru"
};
const CHINESES_LANG = {
  title: "简体中文",
  iso: "zh"
};
const FRENCH_LANG = {
  title: "Français",
  iso: "fr"
};
const ITALIAN_LANG = {
  title: "Italiano",
  iso: "it"
};
const SUPPORTED_LANGUAGES = [GERMAN_LANG, CZECH_LANG, ENGLISH_LANG, FRENCH_LANG, ITALIAN_LANG, SPAIN_LANG, NETHERLANDS_LANG, POLISH_LANG, PORTUGUESE_LANG, RUSSIAN_LANG, CHINESES_LANG];
let HeaderComponent = /*#__PURE__*/(() => {
  class HeaderComponent {
    /** Inputs */
    /** Allows to change the languages, which are selectable by the user. */
    set languages(langs) {
      this._languages.set(langs || []);
      if (this._languages.length > 0) this.activeLanguage.set(this._languages()[0]);else this.activeLanguage.set(null);
    }
    get languages() {
      return this._languages;
    }
    /** Changes the visibility of the mobile menu */
    set mobileMenuVisible(value) {
      if (value != this._mobileMenuVisible()) {
        this._mobileMenuVisible.set(value);
        this._changeDocumentBodyBehaviour();
        this.mobileMenuVisibleChange.emit(value);
      }
    }
    get mobileMenuVisible() {
      return this._mobileMenuVisible;
    }
    /** Allows to change the current active language. */
    set currentLang(val) {
      let lang = this.languages().find(x => x.iso == val);
      if (lang) this.activeLanguage.set(lang);else {
        // English as fallback
        lang = this.languages().find(x => x.iso == "en");
        if (lang) this.activeLanguage.set(lang);
      }
    }
    constructor(_renderer, _cdRef) {
      this._renderer = _renderer;
      this._cdRef = _cdRef;
      /** Outputs */
      /** Emits everytime the user changes the language. */
      this.languageChange = output();
      this.mobileMenuVisibleChange = output();
      this._mobileMenuVisible = signal(false);
      this._languages = signal(SUPPORTED_LANGUAGES);
      this._oldOverflow = "";
      this._oldPosition = "";
      // Current active language, which was selected by the user.
      this.activeLanguage = signal(this._languages()[0]);
      this.fixedHeader = signal(false);
    }
    ngAfterViewInit() {
      this._patchMobileMenu();
      this.menuItems.changes.subscribe(x => {
        this._cdRef.detectChanges(); // Waits until the ui is updated.
        this._patchMobileMenu();
      });
    }
    switchLang(lang) {
      if (this.mobileMenuVisible()) this.mobileMenuVisible = !this.mobileMenuVisible();
      this.activeLanguage.set(this.languages().find(x => x.iso == lang) ?? null);
      this.languageChange.emit(lang);
    }
    /** Modifies the mobile menu, so that submenus can be expanded. */
    _patchMobileMenu() {
      for (const li of this.mobileMenus) {
        let htmlLi = li.nativeElement;
        let anchor = htmlLi.querySelector("a");
        if (anchor) {
          let text = anchor.getAttribute("mobile-text");
          if (text) {
            let icon = htmlLi.querySelector("mat-icon");
            if (icon) {
              this._renderer.setStyle(icon, "padding-right", "10px");
            }
            anchor.innerHTML += text;
          }
          let content = htmlLi.querySelector(".subMenueItem");
          if (content) {
            anchor.removeEventListener("click", this._onMobileMenuClick.bind(this));
            anchor.addEventListener("click", this._onMobileMenuClick.bind(this));
            this._renderer.addClass(anchor, "has-content");
          }
        }
      }
    }
    _onMobileMenuClick(event) {
      let anchor = event.target;
      if (anchor.parentElement.classList.contains("rotate")) this._renderer.removeClass(anchor.parentElement, "rotate");else this._renderer.addClass(anchor.parentElement, "rotate");
      event.preventDefault();
      event.stopPropagation();
    }
    /** Makes the body static, if the mobile menu visible. */
    _changeDocumentBodyBehaviour() {
      if (this.mobileMenuVisible()) {
        this._oldOverflow = window.document.body.style.overflow;
        this._oldPosition = window.document.body.style.position;
        window.document.body.style.overflow = "hidden";
        window.document.body.style.position = "fixed";
      } else {
        window.document.body.style.overflow = this._oldOverflow;
        window.document.body.style.position = this._oldPosition;
      }
    }
    onScroll(event) {
      const scrollElementNumber = event.srcElement.scrollingElement.scrollTop;
      this.fixedHeader.set(scrollElementNumber >= 70);
      if (this.mobileMenuVisible()) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
    static {
      this.ɵfac = function HeaderComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || HeaderComponent)(i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: HeaderComponent,
        selectors: [["esd-theme-header"]],
        contentQueries: function HeaderComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, MenuitemDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuItems = _t);
          }
        },
        viewQuery: function HeaderComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.mobileMenus = _t);
          }
        },
        hostBindings: function HeaderComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("scroll", function HeaderComponent_scroll_HostBindingHandler($event) {
              return ctx.onScroll($event);
            }, false, i0.ɵɵresolveWindow);
          }
        },
        inputs: {
          languages: "languages",
          mobileMenuVisible: "mobileMenuVisible",
          currentLang: "currentLang"
        },
        outputs: {
          languageChange: "languageChange",
          mobileMenuVisibleChange: "mobileMenuVisibleChange"
        },
        decls: 46,
        vars: 31,
        consts: [["mobileMenu", ""], [1, "background-shadow"], [1, "header"], [1, "move-header"], [1, "mobile-sticky-menu", "hide-on-large-only"], ["id", "mobile-button", 1, "mobile-button", 3, "click"], [1, "company-logo"], [1, "spritesheet", "logo-esders-2023"], [1, "links", "hide-on-med-and-down"], [1, "spacer"], [3, "href"], [1, "desktop-menu", "hide-on-med-and-down", 3, "ngClass"], [1, "menuitem"], [1, "mobile-menu", 3, "ngClass"], [1, "title"], [1, "side-menue"], [1, "mobilemenuitem"], [1, "background-shadow", 3, "click"], [1, "flag-container"], [3, "click"], [2, "vertical-align", "middle"], [3, "ngTemplateOutlet"], [1, "subMenueItem"]],
        template: function HeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, HeaderComponent_Conditional_0_Template, 1, 0, "div", 1);
            i0.ɵɵelementStart(1, "div", 2)(2, "div", 3)(3, "div", 4)(4, "div", 5);
            i0.ɵɵlistener("click", function HeaderComponent_Template_div_click_4_listener() {
              return ctx.mobileMenuVisible = !ctx.mobileMenuVisible();
            });
            i0.ɵɵelementStart(5, "mat-icon");
            i0.ɵɵtext(6, "menu");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(7, "div", 6);
            i0.ɵɵelement(8, "div", 7);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "div", 8)(10, "div", 6);
            i0.ɵɵelement(11, "div", 7);
            i0.ɵɵelementEnd();
            i0.ɵɵelement(12, "div", 9);
            i0.ɵɵelementStart(13, "a", 10);
            i0.ɵɵpipe(14, "translate");
            i0.ɵɵelementStart(15, "mat-icon");
            i0.ɵɵtext(16, "phone");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(17, "span");
            i0.ɵɵtext(18);
            i0.ɵɵpipe(19, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(20, "a", 10);
            i0.ɵɵpipe(21, "translate");
            i0.ɵɵelementStart(22, "mat-icon");
            i0.ɵɵtext(23, "email");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(24, "span");
            i0.ɵɵtext(25);
            i0.ɵɵpipe(26, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(27, "a", 10);
            i0.ɵɵpipe(28, "translate");
            i0.ɵɵelementStart(29, "mat-icon");
            i0.ɵɵtext(30, "wb_cloudy");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(31, "span");
            i0.ɵɵtext(32);
            i0.ɵɵpipe(33, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(34, HeaderComponent_Conditional_34_Template, 9, 3, "ul");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(35, "nav", 11);
            i0.ɵɵrepeaterCreate(36, HeaderComponent_For_37_Template, 2, 1, "div", 12, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(38, "div", 13)(39, "div", 14);
            i0.ɵɵtext(40);
            i0.ɵɵpipe(41, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(42, "ul", 15);
            i0.ɵɵrepeaterCreate(43, HeaderComponent_For_44_Template, 3, 1, "li", 16, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵtemplate(45, HeaderComponent_Conditional_45_Template, 8, 4, "li", 16);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            let tmp_7_0;
            let tmp_13_0;
            i0.ɵɵconditional(ctx.mobileMenuVisible() ? 0 : -1);
            i0.ɵɵadvance(13);
            i0.ɵɵpropertyInterpolate("href", i0.ɵɵpipeBind1(14, 13, "links.tel"), i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(19, 15, "links.telefon"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate1("href", "mailto:", i0.ɵɵpipeBind1(21, 17, "links.info"), "", i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(26, 19, "links.info"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("href", i0.ɵɵpipeBind1(28, 21, "links.website"), i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(33, 23, "t_to_website"));
            i0.ɵɵadvance(2);
            i0.ɵɵconditional((tmp_7_0 = ctx.languages().length > 0 && ctx.activeLanguage()) ? 34 : -1, tmp_7_0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(27, _c1, ctx.fixedHeader()));
            i0.ɵɵadvance();
            i0.ɵɵrepeater(ctx.menuItems);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(29, _c2, ctx.mobileMenuVisible()));
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(41, 25, "t_menu"));
            i0.ɵɵadvance(3);
            i0.ɵɵrepeater(ctx.menuItems);
            i0.ɵɵadvance(2);
            i0.ɵɵconditional((tmp_13_0 = ctx.languages().length > 0 && ctx.activeLanguage()) ? 45 : -1, tmp_13_0);
          }
        },
        dependencies: [MatIcon, NgClass, TranslatePipe, NgTemplateOutlet],
        styles: [".header[_ngcontent-%COMP%]{position:relative;line-height:1;background:#fff;z-index:10}@media only screen and (max-width : 992px){.header[_ngcontent-%COMP%]{margin-bottom:1rem}}.header[_ngcontent-%COMP%]   .desktop-menu[_ngcontent-%COMP%]{display:flex;flex-wrap:nowrap;justify-content:center;width:100%;height:70px;background:#fff;z-index:20}@media only screen and (max-width : 992px){.header[_ngcontent-%COMP%]   .desktop-menu[_ngcontent-%COMP%]{display:none}}.header[_ngcontent-%COMP%]   .desktop-menu[_ngcontent-%COMP%]   .menuitem[_ngcontent-%COMP%]{position:relative;transition:color .2s ease-in;border-bottom:1px solid #ffffff;height:calc(100% - 1px);z-index:999}.header[_ngcontent-%COMP%]   .desktop-menu[_ngcontent-%COMP%]   .menuitem[_ngcontent-%COMP%]:hover{border-bottom:1px solid #e2001a}.header[_ngcontent-%COMP%]   .desktop-menu[_ngcontent-%COMP%]   .menuitem[_ngcontent-%COMP%]:hover     .subMenueItem{display:block}.header[_ngcontent-%COMP%]   .desktop-menu[_ngcontent-%COMP%]   .menuitem[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{height:100%}.header[_ngcontent-%COMP%]   .desktop-menu[_ngcontent-%COMP%]   .menuitem[_ngcontent-%COMP%]     a{display:flex;align-items:center;height:calc(100% - 50px);padding:25px;font-size:20px;color:#444;text-decoration:none;line-height:1;text-transform:uppercase;font-size:14pt;background:#fff;white-space:nowrap;cursor:pointer}.header[_ngcontent-%COMP%]   .desktop-menu[_ngcontent-%COMP%]   .menuitem[_ngcontent-%COMP%]     a:hover{color:#e2001a}.header[_ngcontent-%COMP%]   .desktop-menu[_ngcontent-%COMP%]   .menuitem[_ngcontent-%COMP%]     a img{margin-right:5px}.header[_ngcontent-%COMP%]   .desktop-menu[_ngcontent-%COMP%]   .menuitem[_ngcontent-%COMP%]     a i{font-size:18pt}.header[_ngcontent-%COMP%]   .desktop-menu[_ngcontent-%COMP%]   .menuitem[_ngcontent-%COMP%]     .subMenueItem{margin-top:1px;display:none;position:absolute;top:100%;left:0;justify-content:center;box-shadow:0 2px 1px -1px #0003,0 1px 1px #00000024,0 1px 3px #0000001f;border-bottom-left-radius:4px;border-bottom-right-radius:4px}.header[_ngcontent-%COMP%]   .desktop-menu[_ngcontent-%COMP%]   .menuitem[_ngcontent-%COMP%]     .subMenueItem a:last-child{border-radius:4px}.header[_ngcontent-%COMP%]   .desktop-menu[_ngcontent-%COMP%]   .menuitem[_ngcontent-%COMP%]     .subMenueItem a{transition:color .2s ease-in;border-bottom:1px solid #ffffff;height:calc(100% - 1px);color:#444;height:20px;padding:25px}.header[_ngcontent-%COMP%]   .desktop-menu[_ngcontent-%COMP%]   .menuitem[_ngcontent-%COMP%]     .subMenueItem a img{margin:0}.header[_ngcontent-%COMP%]   .desktop-menu[_ngcontent-%COMP%]   .menuitem[_ngcontent-%COMP%]     .subMenueItem a:hover{color:#e2001a}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]{position:relative;height:70px;display:flex}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .company-logo[_ngcontent-%COMP%]{width:200px}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .company-logo[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{transform:translate(-50%) scale(.7);position:relative;left:50%}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .mobile-sticky-menu[_ngcontent-%COMP%]{position:fixed;top:0;background:#fff;width:100%;height:70px;border-bottom:2px solid #e2001a}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .mobile-sticky-menu[_ngcontent-%COMP%]   .mobile-button[_ngcontent-%COMP%]{position:absolute;right:0;top:0;z-index:11;padding-top:10px;line-height:1;padding-bottom:10px;padding-right:10px;display:flex;align-items:center;cursor:pointer;color:#444;text-decoration:none}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .mobile-sticky-menu[_ngcontent-%COMP%]   .mobile-button[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:50px;width:50px;height:50px}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;width:100%;line-height:1;height:100%;background-color:#efefef}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   .spacer[_ngcontent-%COMP%]{flex-grow:.8}@media only screen and (max-width : 992px){.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]{display:none}}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{margin:0 auto;color:#444;text-decoration:none;vertical-align:middle;white-space:nowrap;align-items:center;display:flex}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:#e2001a}@media only screen and (min-width : 1201px){.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{margin:0 25px}}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:25pt;width:25pt;height:25pt;vertical-align:middle;transition:color .2s ease-in-out}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]:hover{color:#e2001a}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{padding-left:10px}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:hover{text-decoration:underline}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{margin:0 auto;position:relative;padding:0 10px;text-align:center;list-style-type:none;border-radius:2px}@media only screen and (min-width : 1201px){.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{margin:0 25px}}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{white-space:nowrap}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover{background-color:#efefef;cursor:pointer}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover   mat-icon[_ngcontent-%COMP%]{transform:rotateX(180deg)}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]:hover   ul[_ngcontent-%COMP%]{display:block}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .flag-container[_ngcontent-%COMP%]{display:inline-block;margin:0;height:20px;padding:10px;transition:color .2s}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .flag-container[_ngcontent-%COMP%]:hover{color:#e2001a}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{padding:0;margin:0;display:none;text-align:left;position:absolute;top:40px;z-index:99999;background:#fff}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{padding:5px}.header[_ngcontent-%COMP%]   .move-header[_ngcontent-%COMP%]   .links[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   .flag-container[_ngcontent-%COMP%]{display:block}.background-shadow[_ngcontent-%COMP%]{display:block;position:absolute;left:0;top:0;height:100%;width:100%;background-color:#0006;z-index:99}.mobile-menu[_ngcontent-%COMP%]{position:fixed;z-index:100;line-height:1;transition:.2s ease-in-out left;left:-250px;top:0;height:100vh;overflow-y:auto;background:#000c;width:250px}.mobile-menu[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{transition:ease-in-out color .2s;font-family:Noto Sans,Noto Sans SC,sans-serif;text-transform:uppercase;font-size:30pt;color:#e2001a;text-align:center;margin:10px 0}.mobile-menu[_ngcontent-%COMP%]   .side-menue[_ngcontent-%COMP%]{padding-left:0}.mobile-menu[_ngcontent-%COMP%]   .side-menue[_ngcontent-%COMP%]   .mobile-lang-selector[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{vertical-align:bottom;padding-right:10px}.mobile-menu[_ngcontent-%COMP%]   .side-menue[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]{height:100%;width:100%;list-style-type:none;position:relative}.mobile-menu[_ngcontent-%COMP%]   .side-menue[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]     a{width:calc(100% - 45px);padding:15px 15px 15px 30px;color:#fff!important;text-decoration:none;transition:ease-in-out color .2s}.mobile-menu[_ngcontent-%COMP%]   .side-menue[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]     a:hover{background-color:#e2001a}.mobile-menu[_ngcontent-%COMP%]   .side-menue[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]{display:none;padding-left:0}.mobile-menu[_ngcontent-%COMP%]   .side-menue[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{width:calc(100% - 60px);padding-left:45px}.mobile-menu[_ngcontent-%COMP%]   .side-menue[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{background-color:#e2001a}.mobile-menu[_ngcontent-%COMP%]   .side-menue[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   ul[_ngcontent-%COMP%]   li[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{font-size:24px;margin:-5px 0;vertical-align:bottom;position:relative}.mobile-menu[_ngcontent-%COMP%]   .side-menue[_ngcontent-%COMP%]     .rotate   .has-content:after{transform:rotate(90deg)}.mobile-menu[_ngcontent-%COMP%]   .side-menue[_ngcontent-%COMP%]     .rotate   .subMenueItem{display:block!important}.mobile-menu[_ngcontent-%COMP%]   .side-menue[_ngcontent-%COMP%]     .rotate   .subMenueItem a{padding-left:40px!important}.mobile-menu[_ngcontent-%COMP%]   .side-menue[_ngcontent-%COMP%]     .mobilemenuitem   .subMenueItem{display:none}.mobile-menu[_ngcontent-%COMP%]   .side-menue[_ngcontent-%COMP%]     .mobilemenuitem   a{display:flex;align-items:center}.mobile-menu[_ngcontent-%COMP%]   .side-menue[_ngcontent-%COMP%]     .mobilemenuitem   a img{padding-right:10px}.mobile-menu[_ngcontent-%COMP%]   .side-menue[_ngcontent-%COMP%]     .mobilemenuitem .has-content:after{color:#fff;content:\"keyboard_arrow_right\";font-family:Material Icons;position:absolute;right:0;top:6px;font-size:25pt;transition:transform .1s ease-in}.show-mobile-menu[_ngcontent-%COMP%]{left:0}"],
        changeDetection: 0
      });
    }
  }
  return HeaderComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of theme
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CHINESES_LANG, CZECH_LANG, DisclaimerService, ENGLISH_LANG, FRENCH_LANG, FooterComponent, GERMAN_LANG, HeaderComponent, ITALIAN_LANG, MenuitemDirective, NETHERLANDS_LANG, POLISH_LANG, PORTUGUESE_LANG, RUSSIAN_LANG, SPAIN_LANG, SUPPORTED_LANGUAGES };
